const getBrowserAndPlatform = () => {
    const nav: any = navigator;

    if (nav.userAgentData?.brands?.length) {
        const brand = nav.userAgentData.brands[0];
        return {
            browser: brand.brand,
            version: brand.version,
            platform: nav.userAgentData.platform,
            mobile: nav.userAgentData.mobile,
        };
    }

    const ua = navigator.userAgent;

    // iOS & iPadOS detection
    const isIPadOS = /iPad/.test(ua) || (/MacIntel/.test(ua) && navigator.maxTouchPoints > 1);

    if (/iPhone|iPod/.test(ua) || isIPadOS) {
        if (/CriOS/.test(ua)) return { browser: 'Chrome', platform: 'iOS' };
        if (/FxiOS/.test(ua)) return { browser: 'Firefox', platform: 'iOS' };
        if (/EdgiOS/.test(ua)) return { browser: 'Edge', platform: 'iOS' };
        if (/OPiOS/.test(ua)) return { browser: 'Opera', platform: 'iOS' };
        if (/Safari/.test(ua) && !/CriOS|FxiOS|EdgiOS|OPiOS/.test(ua)) return { browser: 'Safari', platform: 'iOS' };
    }

    // macOS
    if (/Macintosh/.test(ua)) {
        if (/Chrome/.test(ua)) return { browser: 'Chrome', platform: 'macOS' };
        if (/Edg/.test(ua)) return { browser: 'Edge', platform: 'macOS' };
        if (/Firefox/.test(ua)) return { browser: 'Firefox', platform: 'macOS' };
        return { browser: 'Safari', platform: 'macOS' };
    }

    // Android
    if (/Android/.test(ua)) return { browser: 'Android Browser', platform: 'Android' };

    return { browser: 'Unknown', platform: 'Unknown' };
};

export const getBrowserAndOsDetails = () => {
    const details = getBrowserAndPlatform();
    let browser = '';
    if (details.browser == 'Unknown' && details.platform == 'Unknown') browser = 'Unknown';
    else browser = `${details.browser} on ${details.platform}`;
    return browser;
};
